type langInfo = {
  name: string;
  level: string;
  icon: string;
};

type techStack = {
  title: string;
  tech: langInfo[];
};

const data: techStack[] = [
  {
    title: "languages",
    tech: [
      {
        name: "JavaScript",
        level: "Expert",
        icon: "/assets/img/JavaScript.jpeg",
      },
      {
        name: "HTML5",
        level: "Expert",
        icon: "/assets/img/HTML5.png",
      },
      {
        name: "CSS3",
        level: "Expert",
        icon: "/assets/img/CSS3.png",
      },
      {
        name: "Sass",
        level: "Expert",
        icon: "/assets/img/sass.png",
      },
      {
        name: "PHP",
        level: "Junior",
        icon: "/assets/img/PHP.jpg",
      },
    ],
  },
  {
    title: "Front-End Frameworks",
    tech: [
      {
        name: "Tailwind CSS",
        level: "Mid",
        icon: "/assets/img/tailwindcss.png",
      },
      {
        name: "Bootstrap",
        level: "Senior",
        icon: "/assets/img/Bootstrap.png",
      },
      {
        name: "Styled Components",
        level: "Senior",
        icon: "/assets/img/styled.png",
      },
      {
        name: "Material Ui",
        level: "Mid",
        icon: "/assets/img/material-ui.png",
      },
    ],
  },
  {
    title: "Javascript UI",
    tech: [
      {
        name: "React",
        level: "Expert",
        icon: "/assets/img/React.png",
      },
      {
        name: "Redux",
        level: "Expert",
        icon: "/assets/img/redux.png",
      },
    ],
  },
  {
    title: "databases",
    tech: [
      {
        name: "MySQL",
        level: "Junior",
        icon: "/assets/img/MySQL.png",
      },
      {
        name: "Firestore",
        level: "Junior",
        icon: "/assets/img/firebase.png",
      },
    ],
  },
  {
    title: "Version Control",
    tech: [
      {
        name: "Git",
        level: "Senior",
        icon: "/assets/img/Git.png",
      },
    ],
  },
  {
    title: "Tools",
    tech: [
      {
        name: "VS Code",
        level: "Senior",
        icon: "/assets/img/vscode.png",
      },
    ],
  },
  {
    title: "Graphic Design",
    tech: [
      {
        name: "Figma",
        level: "Senior",
        icon: "/assets/img/Figma.png",
      },
      {
        name: "Adobe Photoshop",
        level: "Junior",
        icon: "/assets/img/photoshop.jpg",
      },
    ],
  },
];

export default data;
